import type { Locale } from "antd/es/locale";
import enUS from "antd/locale/en_US";
import type { SupportedLocale } from "./detectLanguage";

export const loadAntdLocale = async (
  locale: SupportedLocale
): Promise<Locale> => {
  switch (locale) {
    case "en":
      return enUS;
    case "es":
      return (await import("antd/locale/es_ES")).default;
    case "pt-BR":
      return (await import("antd/locale/pt_BR")).default;
    case "fr":
      return (await import("antd/locale/fr_FR")).default;
    case "de":
      return (await import("antd/locale/de_DE")).default;
    case "th":
      return (await import("antd/locale/th_TH")).default;
  }
};
